import { Box, Chip, Grid, Typography } from "@mui/material";
import React from "react";
import PersonIcon from "@mui/icons-material/Person";
import SensorOccupiedIcon from "@mui/icons-material/SensorOccupied";

const LegendItem = ({ children }) => (
	<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
		{children}
	</Box>
);

export const LeyendaRecolectores = () => {
	return (
		<Grid
			container
			direction="row"
			justifyContent="start"
			alignItems="center"
			size={{ xs: 12 }}
			spacing={2}
		>
			<LegendItem>
				<PersonIcon sx={{ fontSize: 25 }} color="primary" />
				<Typography variant="body2">Sin comprobar.</Typography>
			</LegendItem>

			<LegendItem>
				<PersonIcon sx={{ fontSize: 25 }} color="secondary" />
				<Typography variant="body2">Comprobacion correcta.</Typography>
			</LegendItem>

			<LegendItem>
				<PersonIcon sx={{ fontSize: 25 }} color="error" />
				<Typography variant="body2">Comprobacion erronea.</Typography>
			</LegendItem>

			<LegendItem>
				<Chip icon={<SensorOccupiedIcon />} label="0/100" size="small" />
				<Typography variant="body2">Nota comprobacion.</Typography>
			</LegendItem>
		</Grid>
	);
};
